import { createApiClient, createUploader, type ApiClientOptions } from './client'
import { blockTenantWrites, expireSession, token } from './session'

/**
 * The one client the console talks through. Built from the environment so a
 * preview deployment can point at staging without a rebuild of the code, only
 * of the bundle.
 */
const options: ApiClientOptions = {
  baseUrl: import.meta.env.VITE_API_URL ?? '',
  getToken: () => token.value,
  // A rejected token is dead: drop it here so no later call retries with it.
  // The shell watches the token disappear and sends the user to sign in with
  // a note that the session ended, so a page never sits half-loaded.
  onUnauthorised: expireSession,
  // The tenant is read-only for non-payment. Flagging it here means every
  // write control goes quiet at once, whether or not this user may read the
  // subscription that says so; the shell's banner explains.
  onTenantReadOnly: blockTenantWrites,
}

export const api = createApiClient(options)

/** The same session, for the one upload big enough to want a progress bar. */
export const upload = createUploader(options)

export {
  ApiError,
  type FieldErrors,
  isNetworkFailure,
  isReadOnlyToken,
  isRefusal,
  isStepUpRequired,
  isTenantReadOnly,
  machineCode,
  malformed,
  unwrap,
  unwrapList,
} from './client'
export {
  acknowledgeExpiry,
  clearToken,
  sessionExpired,
  setToken,
  tenantReadOnly,
  token,
} from './session'
